"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCloudViewerUrl = void 0;
var constants_1 = require("../../utils/constants");
var parseAttachDetails_1 = require("../../utils/parseAttachDetails");
var parseUrl_1 = require("../../utils/parseUrl");
var prepareRegExps_1 = require("../../utils/prepareRegExps");
var regexps_1 = require("../../utils/regexps");
/** Парсит гет параметры */
var parseQueryParams = function (queryParams) {
    var xEmail = queryParams.get(constants_1.ParamsKeys.XEmail);
    var folderId = queryParams.get(constants_1.ParamsKeys.FolderId);
    var backUrl = queryParams.get(constants_1.ParamsKeys.BackUrl);
    return __assign(__assign({ xEmail: xEmail }, (folderId && { folderId: folderId })), (backUrl && { backUrl: backUrl }));
};
/** Парсит урл облачного просмотрщика */
var parseCloudViewerUrl = function (url, regExps) {
    if (regExps === void 0) { regExps = regexps_1.defaultRegExps; }
    var _a = (0, prepareRegExps_1.prepareRegExps)(regExps), attachPathReg = _a.attachPathReg, urlPartsReg = _a.urlPartsReg, emlFormatId = _a.emlFormatId;
    var result = (0, parseUrl_1.parseUrl)(url, urlPartsReg);
    if (!result) {
        return { result: null, error: constants_1.Errors.Url };
    }
    var host = result.host, attachPath = result.attachPath, queryParams = result.queryParams;
    var decodedAttachPath;
    try {
        decodedAttachPath = decodeURIComponent(attachPath);
    }
    catch (error) {
        return { result: null, error: constants_1.Errors.Decode };
    }
    var parsedData = (0, parseAttachDetails_1.parseAttachDetails)(decodedAttachPath, attachPathReg, emlFormatId);
    if (parsedData === null) {
        return { result: null, error: constants_1.Errors.Ids };
    }
    var messageId = parsedData.messageId, encodedAttachId = parsedData.encodedAttachId;
    var parsedQueryParams = parseQueryParams(queryParams);
    return {
        result: __assign({ host: host, messageId: messageId, encodedAttachId: encodedAttachId }, (parsedQueryParams && { queryParams: parsedQueryParams })),
    };
};
exports.parseCloudViewerUrl = parseCloudViewerUrl;
//# sourceMappingURL=parse.js.map